import { action, computed, observable } from 'mobx';
import { setter } from 'mobx-decorators';
import constants from 'Constants';
import { deserializeWithMappers, setFieldValues } from 'stores/Utils';


class UsageLimitsStore {

  @setter @observable allInOneContactsLimit;
  @setter @observable marketingPlatformContactsLimit;
  @setter @observable aovProgressBarPageviewsLimit;
  @setter @observable backInStockOverallEmailSendsLimit;
  @setter @observable recommenderPageviewsLimit;
  @setter @observable reviewsOrdersLimit;
  @setter @observable reperksOrdersLimit;
  @setter @observable promptPopupViewsLimit;

  static create(data={}) {
    const instance = new UsageLimitsStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "allInOneContactsLimit": 0,
      "marketingPlatformContactsLimit": 0,
      "aovProgressBarPageviewsLimit": 0,
      "backInStockOverallEmailSendsLimit": 0,
      "recommenderPageviewsLimit": 0,
      "reviewsOrdersLimit": 0,
      "reperksOrdersLimit": 0,
      "promptPopupViewsLimit": 0,
    };
  }

  constructor(defaults=UsageLimitsStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=UsageLimitsStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "allInOneContactsLimit", "accessor": "allinone_contacts_limit"},
      {"field": "marketingPlatformContactsLimit", "accessor": "marketingplatform_contacts_limit"},
      {"field": "aovProgressBarPageviewsLimit", "accessor": "aovprogressbar_pageviews_limit"},
      {"field": "backInStockOverallEmailSendsLimit", "accessor": "backinstock_overall_email_sends_limit"},
      {"field": "recommenderPageviewsLimit", "accessor": "recommender_pageviews_limit"},
      {"field": "reviewsOrdersLimit", "accessor": "reviews_orders_limit"},
      {"field": "reperksOrdersLimit", "accessor": "reperks_orders_limit"},
      {"field": "promptPopupViewsLimit", "accessor": "prompt_popup_views_limit"},
    ];
  }

  @action deserialize(data) {
    deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }
}


export default UsageLimitsStore;
